import ButtonScroll from '@/components/ButtonScroll';
import { FloorsDTO } from '@/dto/responseDto/floor';
import { pagination } from '@/util/pagination';
import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import './style.scss';
interface IProps {
    floorActive?: string | number;
    onFloorChange: (id: string) => void;
    onChangeStatus: (ids: number[]) => void;
    data: FloorsDTO[];
    statusRoom: any;
}
const MainHeader: React.FC<IProps> = ({ floorActive, onFloorChange, data, statusRoom, onChangeStatus }) => {
    const [dataPagination, setDataPagination] = useState<any>();
    const [status, setStatus] = useState<any>([1, 2, 3, 4]);
    const [currentPage, setCurrentPage] = useState<number>(Number(localStorage.getItem('currentPageMain')) || 1);

    const onChangePage = (type: 'prev' | 'next') => {
        if (type === 'prev') {
            setCurrentPage(currentPage - 1);
            localStorage.setItem('currentPageMain', `${currentPage - 1}`);
        } else {
            setCurrentPage(currentPage + 1);
            localStorage.setItem('currentPageMain', `${currentPage + 1}`);
        }
    };

    useEffect(() => {
        if (data?.length) {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            data = data?.sort((a: any, b: any) => a?.sortOrder - b?.sortOrder);
            setDataPagination(pagination(data, 4, currentPage));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data, currentPage]);
    const filterStatus = (stt: number) => {
        let prev = status;
        if (prev.includes(stt)) {
            prev = prev.filter((el: number) => el !== stt);
        } else {
            prev = [...prev, stt];
        }
        if (prev.length === 0) {
            prev = [1, 2, 3, 4];
        }
        console.log('prev', prev);

        setStatus(prev);
        return onChangeStatus(prev);
    };
    return (
        <div className="p-main-header">
            <div className="p-main-header__left">
                <div className="floors">
                    {dataPagination?.data?.map((item: FloorsDTO, key: number) => (
                        <div
                            key={key}
                            className={classNames('floor', {
                                '--active': (!floorActive && key === 0) || floorActive === item._id,
                            })}
                            onClick={() => onFloorChange(item._id)}
                        >
                            <h3>{item.name}</h3>
                        </div>
                    ))}
                </div>
                {dataPagination?.data && (!dataPagination?.positionPage?.first || !dataPagination?.positionPage?.last) && (
                    <div className="button-scroll">
                        <ButtonScroll
                            onClick={onChangePage}
                            disabledPrev={!dataPagination || dataPagination?.positionPage?.first}
                            disabledNext={!dataPagination || dataPagination?.positionPage?.last}
                        ></ButtonScroll>
                    </div>
                )}
            </div>

            <div className="p-main-header__right">
                <span
                    className="--free"
                    style={{ borderBottom: status.includes(1) || status.length === 0 ? '4px solid #d9d9d9' : '' }}
                    onClick={() => filterStatus(1)}
                >{`TRỐNG - ${statusRoom?.data?.trong ?? '-'}`}</span>
                <span
                    className="--busy"
                    style={{ borderBottom: status.includes(2) || status.length === 0 ? '4px solid #1890ff' : '' }}
                    onClick={() => filterStatus(2)}
                >{`ĐANG THUÊ - ${statusRoom?.data?.hoatdong ?? '-'}`}</span>
                <span
                    className="--clean"
                    style={{ borderBottom: status.includes(3) || status.length === 0 ? '4px solid #73d13d' : '' }}
                    onClick={() => filterStatus(3)}
                >{`DỌN DẸP - ${statusRoom?.data?.dondep ?? '-'}`}</span>
                <span
                    className="--break"
                    style={{ borderBottom: status.includes(4) || status.length === 0 ? '4px solid #595959' : '' }}
                    onClick={() => filterStatus(4)}
                >{`BẢO TRÌ - ${statusRoom?.data?.baotri ?? '-'}`}</span>
            </div>
        </div>
    );
};

export default React.memo(MainHeader);
